export var BuiltInTypeIds;
(function (BuiltInTypeIds) {
    BuiltInTypeIds[BuiltInTypeIds["Array"] = 15] = "Array";
    BuiltInTypeIds[BuiltInTypeIds["Object"] = 16] = "Object";
    BuiltInTypeIds[BuiltInTypeIds["Uint8Array"] = 17] = "Uint8Array";
    BuiltInTypeIds[BuiltInTypeIds["Uint16Array"] = 18] = "Uint16Array";
    BuiltInTypeIds[BuiltInTypeIds["Uint32Array"] = 19] = "Uint32Array";
    BuiltInTypeIds[BuiltInTypeIds["Int8Array"] = 20] = "Int8Array";
    BuiltInTypeIds[BuiltInTypeIds["Int16Array"] = 21] = "Int16Array";
    BuiltInTypeIds[BuiltInTypeIds["Int32Array"] = 22] = "Int32Array";
    BuiltInTypeIds[BuiltInTypeIds["Float32Array"] = 23] = "Float32Array";
    BuiltInTypeIds[BuiltInTypeIds["Set"] = 24] = "Set";
    BuiltInTypeIds[BuiltInTypeIds["Map"] = 25] = "Map";
    BuiltInTypeIds[BuiltInTypeIds["Date"] = 26] = "Date";
})(BuiltInTypeIds || (BuiltInTypeIds = {}));
//# sourceMappingURL=BuiltInTypeIds.js.map